import useSWRMutation from "swr/mutation";
import { API_REST_METHODS, DEFAULT_LOCALE } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";
import { DataTableSettings } from "../../../common/models/table.model";

export const usePostAnnouncementRequest = ({
    onSuccess = () => {},
    onError = () => {},
}: {
    onSuccess?: (data: any) => void;
    onError?: (err: any, key: string) => void;
}) => {
    const {
        data: announcementRequest,
        trigger: triggerPostAnnouncementRequest,
        isMutating: isLoadingPostAnnouncementRequest,
        reset: resetPostAnnouncementRequest,
    } = useSWRMutation(
        "/api/notification-management/v1/announcement-request",
        async (
            url: string,
            {
                arg,
            }: {
                arg: { body: DataTableSettings; locale?: string };
            }
        ) => {
            const { dateFrom, dateTo, ...rest } = arg.body;

            const data = await fetcher(url, {
                options: {
                    method: API_REST_METHODS.POST,
                    body: JSON.stringify({
                        ...rest,
                        startDateTime: dateFrom ?? null,
                        endDateTime: dateTo ?? null,
                    }),
                },
                locale: arg.locale || DEFAULT_LOCALE,
            });

            if (!data?.request) return data;

            const { startDateTime, endDateTime, ...requestRest } = data.request;
            return {
                ...data,
                request: {
                    ...requestRest,
                    dateFrom: startDateTime ?? null,
                    dateTo: endDateTime ?? null,
                },
            };
        },
        {
            onSuccess,
            onError,
        }
    );

    return {
        announcementRequest,
        triggerPostAnnouncementRequest,
        isLoadingPostAnnouncementRequest,
        resetPostAnnouncementRequest,
    };
};
